<template>
  <b-container fluid>
    <el-page-header
      @back="goBack"
      :title="$l('btn_back') || '返回'"
      :content="$l('page_detail') || '详情'"
    />
    <b-row class="mt-2">
      <!-- 左侧版块 -->
      <b-col cols="12" md="12" :lg="8">
        <b-card>
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <h5>
                {{ formData.custName }}
                <b-badge
                  class="ml-2"
                  style="font-size: 10px"
                  :variant="
                    formData.custStatus === 'Y' ? 'success' : 'secondary'
                  "
                >
                  {{ formData.custStatusText }}
                </b-badge>
              </h5>
              <span style="font-size: 14px; color: #606266">{{
                formData.custFullName
              }}</span>
              <br />
              <span style="font-size: 14px; color: #606266">{{
                formData.custAddress
              }}</span>
              <br />
              <span class="text-muted" style="font-size: 14px">Contact：</span>
              <span style="font-size: 14px">{{ formData.contact }}</span>
              <el-divider direction="vertical"></el-divider>
              <span class="text-muted" style="font-size: 14px">Phone：</span>
              <span style="font-size: 14px">{{ formData.contactPhone }}</span>
              <el-divider direction="vertical"></el-divider>
              <span class="text-muted" style="font-size: 14px">Mobile：</span>
              <span style="font-size: 14px">{{ formData.contactMobile }}</span>
              <br />
              <span class="text-muted" style="font-size: 14px">Email：</span>
              <span style="font-size: 14px">{{ formData.contactEmail }}</span>
              <el-divider direction="vertical"></el-divider>
              <span class="text-muted" style="font-size: 14px">Job：</span>
              <span style="font-size: 14px">{{ formData.contactJob }}</span>
              <el-divider direction="vertical"></el-divider>
              <span class="text-muted" style="font-size: 14px">Website：</span>
              <span style="font-size: 14px">{{ formData.custWebSite }}</span>
            </b-col>
            <b-col cols="auto">
              <a v-b-toggle.collapse-Left1 role="button">
                <i v-if="isLeft1" class="fa fa-chevron-down" title="收起"></i>
                <i v-else class="fa fa-chevron-up" title="展开"></i>
              </a>
            </b-col>
          </b-row>
          <b-collapse v-model="isLeft1" id="collapse-Left1">
            <div>
              <h6 class="mt-3">客户概况：</h6>
              <p
                style="font-size: 14px; color: #606266"
                v-html="formData.custDescription"
              ></p>
              <h6 class="mt-3">合作情况：</h6>
              <p
                style="font-size: 14px; color: #606266"
                v-html="formData.cooperation"
              ></p>
            </div>
            <b-row class="mt-3">
              <b-col cols="12">
                <span class="span-color-dark"
                  >Team：{{ formData.teamName }}</span
                >
                <b-avatar-group size="3rem" overlap="0.15" class="mt-2">
                  <b-avatar
                    v-for="(item, index) in formData.teamPhotoList"
                    :key="index"
                    :src="item.memberImgUrl"
                    v-b-tooltip.hover
                    :title="item.memberUserName"
                  ></b-avatar>
                </b-avatar-group>
              </b-col>
            </b-row>
          </b-collapse>
        </b-card>
        <b-card>
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <h6>业务分析</h6>
            </b-col>
            <b-col cols="auto">
              <a v-b-toggle.collapse-Left2 role="button">
                <i v-if="isLeft2" class="fa fa-chevron-down" title="收起"></i>
                <i v-else class="fa fa-chevron-up" title="展开"></i>
              </a>
            </b-col>
          </b-row>
          <b-collapse v-model="isLeft2" id="collapse-Left2">
            <el-row class="mt-2">
              <el-col :span="12">
                <div style="width: 100%; height: 400px">
                  <v-echarts
                    :option="options"
                    :auto-resize="true"
                    theme="light"
                    style="width: 100%; height: 100%"
                    ref="echartsSales"
                  ></v-echarts>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="d-flex justify-content-center">
                  <h6>品类价格区间分析</h6>
                </div>
                <div style="width: 100%; height: 350px">
                  <v-echarts
                    :option="optionK"
                    :auto-resize="true"
                    theme="light"
                    style="width: 100%; height: 100%"
                    ref="echartsK"
                  ></v-echarts>
                </div>
              </el-col>
            </el-row>
          </b-collapse>
        </b-card>
      </b-col>
      <!-- 右侧版块开始 -->
      <b-col md="12" lg="4">
        <b-card>
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <h6>客户评级</h6>
            </b-col>
            <b-col cols="auto">
              <a v-b-toggle.collapse-Right1 role="button">
                <i v-if="isRight1" class="fa fa-chevron-down" title="收起"></i>
                <i v-else class="fa fa-chevron-up" title="展开"></i>
              </a>
            </b-col>
          </b-row>
          <b-collapse v-model="isRight1" id="collapse-Right1">
            <div class="d-flex mt-2">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >评级结果：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">{{
                  formData.ratingResults
                }}</span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >评级意见：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">美国家居风向标</span>
              </div>
            </div>
            <div style="width: 100%; height: 270px" class="mt-3">
              <v-echarts
                :option="optionsRating"
                auto-resize="true"
                theme="light"
                style="width: 100%; height: 100%"
                ref="echarts1"
              ></v-echarts>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >Customer type：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">{{ formData.customerType }}</span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >Store type：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">{{ formData.storeType }}</span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >Store Count：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">{{ formData.storeCount }}</span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >Definition：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">{{
                  formData.customerDefinition
                }}</span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >Market area：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">{{ formData.marketRegion }}</span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >Competitor：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">{{ formData.competitor }}</span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >Start time：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">{{ formData.startTime }}</span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >Development：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">{{
                  formData.developmentCycle
                }}</span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >Maximum sales：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">{{ formData.maximumSales }}</span>
              </div>
            </div>
            <!-- <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px">Create by：</span>
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">{{ formData.createByName }}</span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px">Create time：</span>
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">{{ formData.createDate }}</span>
              </div>
            </div> -->
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >Modify by：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">{{ formData.modifyByName }}</span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >Modify time：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">{{ formData.modifyDate }}</span>
              </div>
            </div>
          </b-collapse>
        </b-card>
        <b-card>
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <h6>验货要求</h6>
            </b-col>
            <b-col cols="auto">
              <a v-b-toggle.collapse-isRight2 role="button">
                <i v-if="isRight2" class="fa fa-chevron-down" title="收起"></i>
                <i v-else class="fa fa-chevron-up" title="展开"></i>
              </a>
            </b-col>
          </b-row>
          <b-collapse v-model="isRight2" id="collapse-isRight2">
            <div class="d-flex mt-2">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >技术验厂：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px"> Omega </span>
                <span style="font-size: 14px"> 1年 </span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >人权验厂：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px"> Omega </span>
                <span style="font-size: 14px"> 1年 </span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >反恐验厂：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px"> Omega </span>
                <span style="font-size: 14px"> 1年 </span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >测试机构：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px"> BV/ITS/SGS </span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >测试体系：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px"
                  >测试大货样，有效期(PBM/PBT 2年，PBK 1年)</span
                >
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >验货机构：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">WSI QA/ABS DQA</span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >验货体系：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px"
                  >PPM+In-line inspection+Final Inspection</span
                >
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >指定货代：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">Maersk</span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >定舱提前天数：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">14</span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >收汇方式时间：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px">TT 30days</span>
              </div>
            </div>
            <div class="d-flex">
              <div style="width: 180px">
                <span class="text-muted" style="font-size: 14px"
                  >备注说明：</span
                >
              </div>
              <div style="width: 100%">
                <span style="font-size: 14px"></span>
              </div>
            </div>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      formData: {
        custCode: '',
        custNo: '',
        custName: '',
        regionName: '',
        provinceName: '',
        cityName: '',
        districtName: '',
        custAddress: '',
        contact: '',
        contactMobile: '',
        contactPhone: '',
        contactEmail: '',
        contactJob: '',
        custStatus: '',
        custStatusText: '',
        createBy: '',
        createByName: '',
        createDate: '',
        modifyBy: '',
        modifyByName: '',
        modifyDate: '',
        customerType: '',
        storeType: '',
        customerDefinition: '',
        marketRegion: '',
        endCustomers: '',

        custFullName: '',
        custDescription: '',
        custWebSite: '',
        competitor: '',
        startTime: '',
        storeCount: '',
        developmentCycle: '',
        ratingResults: '',
        cooperation: '',
        maximumSales: '',
        teamName: '',
        teamPhotoList: []
      },
      optionsRating: {
        title: {},
        tooltip: {},
        legend: {
          data: []
        },
        radar: {
          shape: 'circle',
          name: {
            textStyle: {
              color: '#fff',
              backgroundColor: '#999',
              borderRadius: 3,
              padding: [3, 5]
            }
          },
          indicator: [
            { name: '合作潜力', max: 3 },
            { name: '利润率', max: 3 },
            { name: '影响力', max: 3 }
          ],
          center: ['50%', '50%'],
          radius: 100
        },
        series: [
          {
            type: 'radar',
            areaStyle: {},
            data: [
              {
                value: [3, 2, 3],
                name: '评分'
              }
            ]
          }
        ]
      },
      options: {
        tooltip: {},
        legend: {
          data: ['2020年度', '2021年度']
        },
        radar: {
          // shape: 'circle',
          name: {
            textStyle: {
              color: '#fff',
              backgroundColor: '#999',
              borderRadius: 3,
              padding: [3, 5]
            }
          },
          indicator: [
            { name: '披巾', max: 6500 },
            { name: '毯子', max: 16000 },
            { name: '靠垫', max: 30000 },
            { name: '床品', max: 38000 },
            { name: '野餐毯', max: 52000 },
            { name: '地垫', max: 25000 }
          ],
          center: ['50%', '45%'],
          radius: 100
        },
        series: [
          {
            name: '当年 vs 明年',
            type: 'radar',
            // areaStyle: {normal: {}},
            data: [
              {
                value: [4300, 10000, 28000, 35000, 50000, 19000],
                name: '2020年度'
              },
              {
                value: [5000, 14000, 28000, 31000, 42000, 21000],
                name: '2021年度'
              }
            ]
          }
        ]
      },
      optionK: {
        tooltip: {
          //   trigger: "axis",
          axisPointer: {
            // type: "cross",
          }
        },
        legend: {},
        xAxis: {
          data: ['披巾', '毯子', '靠垫', '床品', '野餐毯', '地垫']
        },
        yAxis: {
          scale: true,
          splitArea: {
            show: true
          },
          name: '价格（美元）'
        },
        series: [
          {
            type: 'candlestick',
            dimensions: [null, '最低', '最高'],
            // data: [
            //   [1.5, 5],
            //   [2, 6],
            //   [0.5, 3],
            //   [0.8, 4.5],
            //   [2, 3],
            //   [6.5, 12.6],
            // ],
            data: [
              [1.5, 5, 1.5, 5],
              [2, 6, 2, 6],
              [0.5, 3, 0.5, 3],
              [0.8, 4.5, 0.8, 4.5],
              [2, 3, 2, 3],
              [6.5, 12.6, 6.5, 12.6]
            ]
          }
        ]
      },
      isLeft1: false,
      isLeft2: true,
      isRight1: true,
      isRight2: true,
      curParam: {
        prjCode: ''
      }
    }
  },
  // 侦听器
  watch: {
    '$route.params'() {
      if (this.$route.params.custCode) {
        this.formLoad()
      }
    }
  },
  // activated() {
  //   if (this.$route.params.prjCode && this.$route.params.pageType) {
  //     this.isShowLeft2s = true;
  //     this.isShowComments = true;
  //     this.isShowProducts = true;
  //     this.isShowRight = true;
  //     this.formLoad();
  //   }
  // },
  mounted() {
    this.formLoad()
    window.addEventListener('resize', this.resizeTheChart)
  },
  activated() {
    this.formLoad()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeTheChart)
  },
  computed: {
    // 根据打样类型控制tab显隐
    visible() {
      if (this.formData.sampleType === 'N') {
        return { ...this.tabVisible, prjSample: false, material: false }
      } else if (this.formData.sampleType === 'S') {
        return {
          ...this.tabVisible,
          product: false,
          customerRecommend: false,
          quotation: false,
          material: false
        }
      } else if (this.formData.sampleType === 'M') {
        return {
          ...this.tabVisible,
          product: false,
          customerRecommend: false,
          quotation: false,
          prjSample: false
        }
      }
      return {}
    },
    attrParams() {
      return {
        infoCode: this.formData.prjCode,
        templateCategoryCode: this.formData.prjCategoryCode,
        masterCategoryCode: this.formData.masterCategoryCode,
        templateType: 'P'
      }
    },
    prjParams() {
      return {
        prjCode: this.formData.prjCode,
        prjCategoryCode: this.formData.prjCategoryCode,
        masterCategoryCode: this.formData.masterCategoryCode
      }
    },
    Left2Params() {
      return {
        prjCode: this.formData.prjCode
      }
    },
    addLeft2Params() {
      return {
        linkPrjCode: this.formData.prjCode,
        custCode: this.formData.custCode,
        formTitle: this.$l('INDEX.label_title_add_Left2') || '新增子项目'
      }
    },
    commentsParams() {
      return {
        prjCode: this.formData.prjCode
      }
    },
    docsParams() {
      return {
        prjCode: this.formData.prjCode
      }
    },
    productParams() {
      return {
        prjCode: this.formData.prjCode
      }
    }
  },
  methods: {
    formLoad() {
      let custCode = this.$route.params.custCode
      this.curParam.custCode = custCode
      this.refresh()
    },
    refresh() {
      let param = { custCode: this.curParam.custCode }
      this.$api.custInfoDetailApi(param).then((res) => {
        this.formData = res.body
        this.formData.custFullName =
          'William Sonoma Inc（WILLIAMS-SONOMA SINGAPORE PTE. LTD.通过新加坡公司付款）'
        this.formData.custDescription =
          '威廉.索拿马公司（WSI）总部在美国旧金山，成立于1956年的高品质家居用品美国专业零售商、邮购商和电商。客户公司名全称： William Sonoma Inc， 简称 WSI, 所以 WSI 是指公司名称，总部在美国旧金山。上海办称为 WSGO.  <br/>WSI 最早做厨具，商店名称就叫 Williams Sonoma， 和公司同名，是中高档的厨具餐具公司。8个品牌：William Sonoma Inc/ Pottery Barn Furniture/ Pottery Barn Kids /  Pottery Barn Teen /West Elm /William Sonoma Home/ Rejuvenation / Mark and Graham（灯具/hard goods). </br>8个品牌中 PB, PBK, PBT, WSH, WE这 5个是我们的目标客户，按照定单量的大小排列： PB, WE, PBK, PBT, WSH。</br>其中 PTR（零售）,PTM（邮购）, PKR（零售）, PKM（邮购）,WS, WSH 针对富人阶层，PB, PBK, PBT针对中产及以上的消费群体，价格相对较高。</br>其中WE（West Elm）成立于2000年，走年轻时尚的路线，价格相对低，针对白领阶层，总部在纽约。目前在韩国/中东/英国/澳大利亚/墨西哥/加拿大/波多黎各/菲律宾等国家有专卖店。'
        this.formData.custWebSite = 'www.potterybarn.com'
        this.formData.competitor = 'RH'
        this.formData.startTime = '2017'
        this.formData.storeCount = '600'
        this.formData.developmentCycle = 'SP/SU/FL/HO'
        this.formData.ratingResults = 'A'
        this.formData.maximumSales = '$15 million'
        this.formData.teamName = '蚂蚁军团 EU3'
        this.formData.cooperation =
          '8个品牌中PB, PBK, PBT这3个品牌在合作，主要产品是Throw/Pillow/Blanket/Bedding ，重点需要扩大Bedding的占比.  <br/>  目前需要进攻的品牌 ： <br/> West Elm（Throw/Pillow/Bedding/Rug） <br/>PBM的Bedding<br/>William Sonoma 厨房纺织品'
        this.formData.teamPhotoList = [
          {
            memberImgUrl:
              'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202008/600925baa7f3b18fc22a7fe150427bbd.png',
            memberUserName: 'Admin'
          },
          {
            memberImgUrl:
              'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202010/5ae5aae18d07f1187d87508607f1cd71.jpg',
            memberUserName: 'Danny'
          },
          {
            memberImgUrl:
              'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202010/6a374a606a5d77ad51d4cdb9f85160af.png',
            memberUserName: 'Dingding'
          },
          {
            memberImgUrl:
              'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202008/f99a368508cd91344e89a124481206bc.jpeg',
            memberUserName: 'Grace Lee'
          },
          {
            memberImgUrl:
              'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202010/99ad727c2839d7a4a308178b70123b9b.jpg',
            memberUserName: 'Terrence'
          }
        ]
      })
      //   // 刷新界面
      //   this.$api.projectInfoViewDetailApi(this.curParam).then((res) => {
      //     this.formData = res.body;
      //     // 替换项目说明中的回车为br标签
      //     this.formData.prjMemo = this.formData.prjMemo
      //       .replace(/\n*$/g, "")
      //       .replace(/\n/g, "<br/>");

      //     this.curParam.prjCode = this.formData.prjCode;
      //     this.Left2Params.prjCode = this.formData.prjCode;
      //     this.commentsParams.prjCode = this.formData.prjCode;
      //     this.docsParams.prjCode = this.formData.prjCode;
      //     this.productParams.prjCode = this.formData.prjCode;
      //   });
    },
    resizeTheChart() {
      if (this.$refs && this.$refs.echarts1) {
        this.$refs.echarts1.resize()
        this.$refs.echartsSales.resize()
        this.$refs.echartsK.resize()
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    questionShow(val) {
      if (val === '') {
        return
      }
      this.updateStatus = val
      if (val === 'F') {
        this.question = this.$l('tips_question_delete') || '是否要删除当前项目?'
      } else if (val === 'P') {
        this.question =
          this.$l('tips_question_reprocess') || '是否要重新启用当前项目?'
      } else {
        this.question = this.$l('tips_question_save') || '是否要保存更改?'
      }
      this.questionDialogVisible = true
    },
    projectMapShow() {
      this.projectMapDialogVisible = true
    },
    projectMapDialogOpened() {
      this.$nextTick(() => {
        this.$refs.projectMap.init()
      })
    },
    updateProjectStatus() {
      if (this.updateStatus === '') {
        return
      }
      this.formData.prjStatus = this.updateStatus
      this.$api.projectInfoUpdateStatusApi(this.formData).then(() => {
        this.$message({
          showClose: true,
          message: this.$l('tips_save_ok') || '保存成功！',
          type: 'success'
        })
      })
      this.questionDialogVisible = false
    },
    completeProject(ref, val) {
      const opt = {
        complete: this.$l('tips_complete_title') || '完成确认',
        stop: this.$l('tips_stop_title') || '终止确认'
      }
      // 设置标题
      this.formOption.title = opt[ref]
      this.formOption.dialogSaveBtnVisible = true
      // 显示表单
      this.formOption.dialogFormVisible = true
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.form.fromLoad(ref, val)
      }, 0)
    },
    save() {
      this.$refs.form.save()
    },
    saveSuccess() {
      this.formLoad()
      this.cancel()
    },
    cancel() {
      this.formOption.dialogFormVisible = false
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.projectMapDialogVisible = false
    next()
  }
}
</script>
<style lang="scss">
.prject_map_dialog {
  height: 70%;
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      z-index: 9999;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
}
.hidden-header {
  display: none;
}
.file-row-style {
  border-radius: 5px;
  border: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
}
.file-badge-style {
  width: 50px;
  height: 50px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.span-color-dark {
  color: #6c757d;
  font-size: 0.9375rem;
  font-weight: 500;
}
</style>
